import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { Provider } from 'react-redux'
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from 'react-cookie';

import store from "./redux/store.js"

import './css/App.css';
import './css/Mob.css';
import './css/index.css';
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
	
		<Provider store={store}>
			<BrowserRouter>
				<CookiesProvider>
      				<App />
    			</CookiesProvider>
			</BrowserRouter>
		</Provider>
	
);
